import { SettingsServerData } from "@sportal/api";
import { LoginFailureAction } from "../../pages/login/login.types";

export const LOAD_SETTINGS = "[AUTH] LOAD_SETTINGS";
export const GET_SETTINGS_SUCCESS = "[AUTH] GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILURE = "[AUTH] GET_SETTINGS_FAILURE";

export type SettingsSuccessPayload = Pick<
  SettingsServerData,
  "services" | "reporting"
>;

export type SettingsFailurePayload = object & { code: number | string };

export interface LoadSettingsAction {
  type: typeof LOAD_SETTINGS;
}

export interface GetSettingsSuccess {
  type: typeof GET_SETTINGS_SUCCESS;
  payload: SettingsSuccessPayload;
}

interface GetSettingsFailure {
  type: typeof GET_SETTINGS_FAILURE;
  payload: SettingsFailurePayload;
}

export type SettingsActionTypes =
  | LoadSettingsAction
  | GetSettingsSuccess
  | GetSettingsFailure
  | LoginFailureAction;
